// extracted by mini-css-extract-plugin
export default {"heading-5":"_3jXxT _1R_Wx","heading5":"_3jXxT _1R_Wx","background-color":"#F2F2F2","backgroundColor":"#F2F2F2","heading":"P7dpQ _3jXxT _1R_Wx","productSizes":"ZlNSC","size":"_197Vi"};